import pickBy from 'utils/pickBy';

import convertBackgroundToPolotno from '../backgrounds/convertBackgroundToPolotno.js';
import mergePageSpec from './mergePageSpec.js';

/**
 * Set the Polotno page style in the Polotno store.
 * @param {object} page Polotno page
 * @param {object} style Parabo page style data
 * @param {string} styleName Parabo style name
 * @param {Array} photos Parabo photos
 * @param {object} template Parabo template data
 * @returns {undefined}
 */
const setPageStyle = (page, style, styleName, photos, template) => {
  const { custom } = page;
  // Get the page specification without the override object and with new style.
  const spec = mergePageSpec(custom.originalPage, { override: {}, style });
  // Get the Polotno page properties for new style.
  const props = {
    background: convertBackgroundToPolotno(custom.originalPage, spec, photos, template),
    custom: { ...custom, style, styleName },
  };
  const definedProps = pickBy(props, value => value != null);
  page.set(definedProps);
};

export default setPageStyle;
